import React from 'react';

import { Row, Col, Typography } from 'antd';

const { Title } = Typography;

const CategoryHeader: React.FC = () => {
  return (
    <Row className="mt-8" justify="space-between">
      <Col>
        <Title level={2}>Categorias</Title>
      </Col>
    </Row>
  );
};

export default CategoryHeader;
